export default __webpack_public_path__ + "static/media/omitir-permiso-microfono-windows.f182cd6a.svg";